import { catalogTools } from "@/composables/webmcp/tools.catalog";
import { contentTools } from "@/composables/webmcp/tools.content";
import { helpAnswerTools } from "@/composables/webmcp/tools.help";
import { subscriptionTools } from "@/composables/webmcp/tools.subscription";

/**
 * Registra as tools WebMCP de alcance global — catálogo, navegação, conteúdo
 * (artigos, modelos, novidades), respostas do FAQ e o funil de assinatura. São
 * as que fazem sentido em qualquer página do site.
 *
 * Fica num plugin, e não no layout, porque o `modelContext` vive enquanto o
 * DOCUMENTO viver: registrar uma vez por documento é exatamente o ciclo certo.
 * O layout re-executaria a cada troca de rota sem necessidade.
 *
 * Tools de escopo estreito (conta, créditos, downloads, cancelamento, player e
 * galeria) NÃO entram aqui — são registradas pela própria página ou pelo
 * componente, via `useWebMcpTools`, e somem quando a pessoa sai dela. Cada tool
 * registrada ocupa espaço no contexto do agente.
 *
 * `.client` porque `document.modelContext` só existe no browser.
 */
export default defineNuxtPlugin(() => {
  if (!isWebMcpAvailable()) return;

  useWebMcpTools((ctx) => [
    ...catalogTools(ctx),
    ...contentTools(ctx),
    ...helpAnswerTools(ctx),
    ...subscriptionTools(ctx),
  ]);
});
